import PropTypes from 'prop-types'
import TlPaymentMethodsApiV2 from 'api/v2/admins/tl-payment-methods-api-v2'
import { useField } from 'formik'
import React, { useEffect, useState } from 'react'
import ReactAsyncMultiselectField from 'components/molecules/react-async-multiselect-field/'


const defaultProps = {
  label      : '',
  required   : false,
  isMultiple : true,
  propTypes  : ''
}

const propTypes = {
  label       : PropTypes.string,
  required    : PropTypes.bool,
  isMultiple  : PropTypes.bool,
  placeholder : PropTypes.string
}

/**
 * Search field to select warehouse location by its name
 * @param {Object} props - props object
 */
const PaymentMethodAsyncMultiSelectSearchField = ({
  label,
  required,
  isMultiple,
  placeholder,
  ...props
}) => {
  const [ inputValue, setInputValue ]    = useState('')
  const [ dataSelected,setDataSelected ] = useState([])
  const [ isLoading, setIsLoading ]      = useState(true)

  // * Do this to get helper object from useField
  // eslint-disable-next-line no-unused-vars
  const [ field, meta, helper ] = useField(props)

  useEffect(() => {
    if (!field.value) return
    let currentValue  = field.value.toString()
    let splittedValue = []
    if (currentValue !== '') {
      splittedValue = currentValue.split(',')
      getTlPaymentMethods('', splittedValue)
        .then((response) => {
          setDataSelected([ ...dataSelected, ...response ])

        })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])
  // search TlBanks by bank name
  const getTlPaymentMethods = (name, ids) => {
    setIsLoading(true)
    const tableState        = null
    const additionalFilters = {
      name : name,
      ids  : ids
    }
    const tlPaymentMethods  = TlPaymentMethodsApiV2.get({ tableState, ...additionalFilters })
      .then((response) => response.data.tl_payment_methods)
      .finally(() => setIsLoading(false))
    return tlPaymentMethods
  }

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    <>
      <span className='mr-3'>{ option.category }</span>
      <span className='mr-3'>{ '-' }</span>
      <span className='mr-3'>{ option.name }</span>
    </>
  )

  const loadOptions = async () =>  {
    if (isMultiple === false && setDataSelected.length === 1){
      alert('Maaf, Anda sudah memilih payment method sebelumnya. Silahkan ulangi lagi memilih.')

      setDataSelected([])
    }
    else {
      let result = await getTlPaymentMethods(inputValue)
      return result
    }
  }

  const handleCustomChange = (options) => {
    // * prevent undefined value
    if (options) {

      // * set specific value to the formikBag.values
      const optionValue = options.map((options) => options.id)
      const joinValue   = optionValue.join(',')
      helper.setValue(joinValue)
    }
    else {
      // * we should keep update the formik value
      // * If user remove all options, we update to empty array
      helper.setValue('')
    }
    setDataSelected(options)
  }

  return (
    <ReactAsyncMultiselectField
      name={ field.name }
      label={ label }
      placeholder={ placeholder }
      handleCustomChange={ handleCustomChange }
      getOptionLabel={ getOptionLabel }
      required= { required }
      isLoading={ isLoading }
      loadOptions={ loadOptions }
      setInputValue={ setInputValue }
      dataSelected={ dataSelected }
      { ...props }
    />
  )
}

PaymentMethodAsyncMultiSelectSearchField.propTypes    = propTypes
PaymentMethodAsyncMultiSelectSearchField.defaultProps = defaultProps

export default PaymentMethodAsyncMultiSelectSearchField
